/* eslint-disable */
export default function currencyFormat(amount, decimalCount = 2, code = 'USD', decimal = ".", thousands = ",")
{
    let finalValue = '0.00';

    try {
        decimalCount = Math.abs(decimalCount);
        decimalCount = isNaN(decimalCount) ? 2 : decimalCount;

        const negativeSign = amount < 0 ? "-" : "";

        let i = parseInt(amount = Math.abs(Number(amount) || 0).toFixed(decimalCount)).toString();
        let j = (i.length > 3) ? i.length % 3 : 0;

        finalValue = negativeSign + (j ? i.substr(0, j) + thousands : '') + i.substr(j).replace(/(\d{3})(?=\d)/g, "$1" + thousands) + (decimalCount ? decimal + Math.abs(amount - i).toFixed(decimalCount).slice(2) : "");
    } catch (e) {}

    if (code === null)
        return finalValue;

    if (code === 'USD')
        return `$${finalValue}`;

    return `${finalValue} ${code}`;
}
